export default __webpack_public_path__ + "static/media/banner-image_homepage-default-2.e0e54684.png";